import { _ as __rest } from './_tslib.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { generateClasses } from '@ids/tools';
import 'react';
import { u as useId } from './use-id.js';
import { I as IdsIcon } from './icon.js';
import { s as styleInject } from './style-inject.es.js';

var css_248z = ".ids-form-message {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  color: var(--ids_color_action_neutral_base);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font: var(--ids_textStyle_f02_s14_h20_wrg);\n  margin-right: var(--ids_spacing_2x);\n}\n.ids-form-message .ids-icon {\n  margin: 0 var(--ids_spacing_2x);\n}\n.ids-form-message--error {\n  color: var(--ids_color_feedback_error);\n}\n.ids-form-message--disabled {\n  color: var(--ids_color_action_disabled_variant);\n}\n.ids-form-message--hidden {\n  display: none;\n}\n.ids-form-message--on-brand {\n  color: var(--ids_color_contrast_onBrand_primary);\n}\n.ids-form-message--on-brand.ids-form-message--disabled {\n  color: var(--ids_color_contrast_onBrand_primary_medium);\n}";
styleInject(css_248z);

/**
 * @category Component
 *
 * @example
 * ```ts
 * import { IdsFormMessage } from '@ids/react';
 * ```
 */
const IdsFormMessage = _a => {
  var {
      id: externalId,
      children,
      show = true,
      status,
      'aria-live': ariaLive = 'polite',
      className = ''
    } = _a,
    props = __rest(_a, ["id", "children", "show", "status", 'aria-live', "className"]);
  const id = useId(externalId, 'ids-message');
  const classes = generateClasses({
    'ids-form-message': true,
    'ids-form-message--disabled': status === 'disabled',
    'ids-form-message--error': status === 'error',
    [className]: className
  });
  return jsx("div", Object.assign({
    className: classes
  }, props, {
    children: show && jsxs(Fragment, {
      children: [status === 'error' && jsx(IdsIcon, Object.assign({
        size: "S"
      }, {
        children: "aviso_outline"
      })), ' ', jsx("span", Object.assign({
        id: id,
        "aria-live": ariaLive
      }, {
        children: children
      }))]
    })
  }));
};

export { IdsFormMessage as I };
//# sourceMappingURL=form-message.js.map
